import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LogoutButton from "./auth/LogoutButton";
import {
  FaPhoneAlt,
  FaEnvelopeOpen,
  FaRegUser,
  FaRegHeart,
  FaShoppingBasket,
  FaApple,
} from "react-icons/fa";

const TopBar: React.FC = () => {
  const { user: currentUser } = useAuth();

  return (
    <div className="w-full h-[45px] bg-[#231B1B] text-white px-5 lg:px-36">
      <div className="flex justify-between items-center h-full text-sm">
        <div className="flex flex-col items-start text-xs gap-0 lg:items-center lg:gap-5 lg:flex-row">
          <div className="flex items-center gap-2">
            <FaPhoneAlt />
            <p>8 800 555 35 35</p>
          </div>
          <div className="flex items-center gap-2">
            <FaEnvelopeOpen />
            <p>storestore@info.com</p>
          </div>
        </div>

        <div className="flex justify-center items-center gap-5">
          {/* <div className="md:flex items-center gap-5 hidden">
            <a
              href="https://www.instagram.com/"
              className="hover:text-gray-400"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.instagram.com/"
              className="hover:text-gray-400"
            >
              <FaVk />
            </a>
            <a
              href="https://www.instagram.com/"
              className="hover:text-gray-400"
            >
              <FaFacebookSquare />
            </a>
            <a
              href="https://www.instagram.com/"
              className="hover:text-gray-400"
            >
              <FaTelegramPlane />
            </a>
          </div> */}
          <div className="flex items-center gap-1">
            <FaRegUser />
            {currentUser ? (
              <div className="flex items-center gap-4">
                <span>{currentUser.email}</span>
                <LogoutButton />
              </div>
            ) : (
              <>
                <Link to="/login">Login</Link>
                <p>/</p>
                <Link to="/register">Register</Link>
              </>
            )}
          </div>

          <div className="flex justify-center items-center gap-2 h-full">
            <Link to="/favorites">
              <FaRegHeart />
            </Link>
            <Link to="/basket">
              <FaShoppingBasket />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Header = () => {
  return (
    <nav className="flex w-full h-[80px] bg-white shadow-md px-5 lg:px-36">
      <div className="flex w-full justify-between items-center">
        <div className="font-Hubballi text-1xl lg:text-4xl border border-black px-3 py-1">
          <Link to={"/"}>MOBILE+</Link>
        </div>
        <div className="flex items-center text-lg uppercase lg:text-2xl gap-4 lg:gap-8">
          <Link to={"/"} className="hover:text-[#ea4636]">
            Home
          </Link>
          {/* <div className="relative group">
            <a
              href="/catalogue/all_products.html"
              className="hover:text-[#ea4636] flex items-center"
            >
              Shop <i className="fa fa-angle-down ml-1"></i>
            </a>
            <div className="absolute hidden group-hover:flex flex-col bg-white shadow-lg p-4 w-[200px] top-full left-[-100px] z-[111]">
              <a
                href="/catalogue/all_products.html"
                className="text-sm lg:text-base"
              >
                All Products
              </a>
              <a href="/" className="text-sm lg:text-base">
                Iphone
              </a>
              <a href="/" className="text-sm lg:text-base">
                Samsung
              </a>
              <a href="/" className="text-sm lg:text-base">
                OnePlus
              </a>
              <a href="/" className="text-sm lg:text-base">
                Huawei
              </a>
            </div>
          </div> */}
          <Link
            to={"/products"}
            className="flex items-center hover:text-[#ea4636]"
          >
            Shop
          </Link>
          <Link
            className="hidden md:flex items-center hover:text-[#ea4636]"
            to="product/apple"
          >
            <FaApple />
            Apple
          </Link>
          <Link className="hidden md:block hover:text-[#ea4636]" to="product/samsung">
            Samsung
          </Link>
          <a href="/support" className="hover:text-[#ea4636]">
            Support
          </a>
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
